<div class="input-group input-group-sm datepicker-component">
  <span class="input-group-text pointer" (click)="dp.toggle()"><fa-icon [icon]="['fas', 'calendar-alt']"></fa-icon></span>

  <input class="form-control"
    type="text"
    autocomplete="off"
    [formControl]="datepickerFormControl"
    [formlyAttributes]="field"
    [placement]="placement"
    [bsConfig]="{ dateInputFormat: dateFormat, containerClass: 'theme-dark-blue' }"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [class.is-invalid]="showError"
    triggers="keydown click"
    #dp="bsDatepicker"
    bsDatepicker
    readonly>
</div>
